module.exports = __webpack_public_path__ + "static/media/light-motion-spacecraft-design-analysis.4b8d27a.mp4";